import {
    Component
    , ViewChild
    , Input
    , Output
    , EventEmitter
    , OnInit
    , ElementRef
} from '@angular/core';
import { TreeviewItem, TreeviewConfig, TreeviewComponent } from 'ngx-treeview';

@Component({
    moduleId: module.id,
    selector: 'angular-treeview',
    templateUrl: 'treeview.html',
    styleUrls: ['treeview.css']
})
export class AngularTreeviewComponent implements OnInit {

    @Input() items: TreeviewItem[] = new Array<TreeviewItem>();
    @Input() height: number;
    @Input() width: number;
    @Input() selezionaTutto:string="Seleziona tutto";
    @Input() showBorder: boolean = false;
    @ViewChild("tree") tree: TreeviewComponent;
    @ViewChild("treeDiv") treeDiv: ElementRef;
    @Output() selectedChange = new EventEmitter();

    allCollapsed: boolean = true;
    allChecked: boolean = false;
    allIndeterminate: boolean = false;
    totItems: number = 0;
    totChecked: number = 0;
    
    config;

    ngOnInit(): void {
        this.config = TreeviewConfig.create({
            hasAllCheckBox: false,
            hasFilter: false,
            hasCollapseExpand: false,
            decoupleChildFromParent: false,
            maxHeight: this.height - 40
        });
    }

    reset() {
        let container = this.treeDiv.nativeElement.querySelector('.treeview-container');
        if (container) container.scrollTop = 0;
        this.allIndeterminate = false;
        this.allChecked = false;
        this.allCollapsed = true;
        this.items.forEach(a => a.setCheckedRecursive(this.allChecked));
        this.items.forEach(a => a.setCollapsedRecursive(this.allCollapsed));
        this.tree.raiseSelectedChange();
        this.totChecked = 0;
    }

    collapseAll() {
        this.allCollapsed = true;
        this.items.forEach(a => a.setCollapsedRecursive(this.allCollapsed));
    }

    getValues(): any[] {
        return this.tree.selection.checkedItems.map(x => x.value);
    }

    toggleExpand() {
        this.allCollapsed = !this.allCollapsed;
        this.items.forEach(a => a.setCollapsedRecursive(this.allCollapsed));
    }

    toggleCheckAll() {
        this.allIndeterminate = false;
        this.items.forEach(a => a.setCheckedRecursive(this.allChecked));
        this.tree.raiseSelectedChange();
    }

    setChecked(values: any[]) {
        setTimeout(() => {
            this.items.forEach(a => a.setCheckedRecursive(this.allChecked));
            this.tree.raiseSelectedChange();
            this.tree.selection.uncheckedItems.filter(a => values.includes(a.value)).forEach(b => b.checked = true);
            this.correctChecked();
            this.tree.raiseSelectedChange();
        }, 0);
    }

    correctChecked() {
        this._correctChecked(this.items);
    }

    _correctChecked(items: TreeviewItem[]) {
        if (!items || items.length < 1) return;
        items.forEach(a => {
            a.correctChecked();
            this._correctChecked(a.children);
        });
    }

    onSelectedChange(e) {
        let s = this.tree.selection;
        if (s.checkedItems.length > 0) {
            if (s.uncheckedItems.length == 0) {
                this.allIndeterminate = false;
                this.allChecked = true;
            }
            else {
                this.allIndeterminate = true;
                this.allChecked = false;
            }
        }
        else {
            this.allIndeterminate = false;
            this.allChecked = false;
        }
        this.totChecked = s.checkedItems.length;
        this.totItems = s.checkedItems.length + s.uncheckedItems.length;
        this.selectedChange.emit(e);
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/components/treeview/treeview.component.ts